import * as actionTypes from '../constants/loadInfoConstants'


const initialState =
    {

        display:'none',
    };

export default function loadInfo(state = initialState, action) {
    switch (action.type) {
        // 加载页面的 展示状态控制
        case actionTypes.CHANGE_STYLE:
            return action.data;

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/loadInfo.js